import {
    apiRequest,
    // acmanajerialLevel,
    undanganpelantikanDetail,
    generateDocument,
    generateDocumentUndanganSaksi,
    generateInvPegawai,
    generateInvRohaniawan,
    generateDocumentSPMT,
    getDocPelantikan,
    getDocUndanganSaksi,
    getInvPegawai,
    getInvRohaniawan,
    getDocSPMT,
    undanganpelantikanInactive
} from "../../../../../services/adapters/kepegawaian/undanganPelantikanService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", undanganpelantikanDetail, {
            params: query
        }, true)
    }

    // fetchLevel = async (query) => {
    //     return await apiRequest("get", acmanajerialLevel, {
    //         params: query
    //     }, true)
    // }
    fetchGenerateDocument = async (query) => {
        return await apiRequest("get", generateDocument, {
            params: query
        }, true)
    }
    fetchGenerateUndanganSaksi = async (query) => {
        return await apiRequest("get", generateDocumentUndanganSaksi, {
            params: query
        }, true)
    }
    fetchGenerateInvPegawai = async (query) => {
        return await apiRequest("get", generateInvPegawai, {
            params: query
        }, true)
    }
    fetchGenerateInvRohaniawan = async (query) => {
        return await apiRequest("get", generateInvRohaniawan, {
            params: query
        }, true)
    }
    fetchGenerateDocumentSPMT = async (query) => {
        return await apiRequest("get", generateDocumentSPMT, {
            params: query
        }, true)
    }
    fetchDetailDokpelantikan = async (query) => {
        return await apiRequest("get", getDocPelantikan, {
            params: query
        }, true)
    }
    fetchDetailDokUndanganSaksi = async (query) => {
        return await apiRequest("get", getDocUndanganSaksi, {
            params: query
        }, true)
    }
    fetchDetailInvPegawai = async (query) => {
        return await apiRequest("get", getInvPegawai, {
            params: query
        }, true)
    }
    fetchDetailInvRohaniawan = async (query) => {
        return await apiRequest("get", getInvRohaniawan, {
            params: query
        }, true)
    }
    fetchDetailDokSPMT = async (query) => {
        return await apiRequest("get", getDocSPMT, {
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", undanganpelantikanInactive, {
            body: query
        }, true)
    }
}

export default DetailRepository